import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { ShipmentDetailMagento } from '../../models';
import { TmsWebBaseService } from '../base/tms-web-base.service';

@Injectable({
  providedIn: 'root',
})
export class ShipmentDetailMagentoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('ShipmentDetailMagento', httpService);
  }

  importShipmentDetails(): Observable<ShipmentDetailMagento[]> {
    return this.httpService.post<ShipmentDetailMagento[]>(`${this.apiUrl}/ImportShipmentDetails`, {});
  }
}
